import React, { useEffect, useState } from 'react';
import axios from 'axios';

function AnalyticsDashboard() {
  const [caseStats, setCaseStats] = useState({ open: 0, closed: 0, overdue: 0 });
  const [revenue, setRevenue] = useState(0);
  const [tasks, setTasks] = useState([]);
  const [emailsSentToday, setEmailsSentToday] = useState(0);

  const [cases, setCases] = useState([]);
  const [totalCases, setTotalCases] = useState(0);

  const getCases = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cases`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setCases(res.data);
      setTotalCases(res.data.length); // Set total count here
    } catch (err) {
      console.error("Error fetching cases:", err);
    }
  };

  const fetchAnalytics = async () => {
    try {
      const caseRes = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cases/stats`);
      const revenueRes = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/billing/total`);
      const taskRes = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/tasks`);

      setCaseStats(caseRes.data);
      setRevenue(revenueRes.data.totalRevenue);
      setTasks(taskRes.data);
    } catch (error) {
      console.error('Error fetching analytics:', error);
    }
  };

  const fetchEmailsSentToday = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/analytics/emails/today`);
      setEmailsSentToday(res.data.emailsSentToday);
    } catch (err) {
      console.error('Error fetching today\'s email count:', err);
    }
  };

  useEffect(() => {
    fetchAnalytics();
    getCases();
    fetchEmailsSentToday(); // Fetch email count on mount
  }, []);

  return (
    <div className="space-y-6 p-4">
      <h2 className="text-2xl font-bold mb-4 text-white">Analytics Dashboard</h2>

      {/* Case Statistics */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="bg-white p-4 rounded shadow">
  <h3 className="text-lg font-semibold">Total Project</h3>
  <p className="text-2xl">{totalCases}</p>
</div>

        <div className="bg-white p-4 rounded shadow">
          <h3 className="text-lg font-semibold">Closed Project</h3>
          <p className="text-2xl">{caseStats.closed}</p>
        </div>
        <div className="bg-white p-4 rounded shadow">
          <h3 className="text-lg font-semibold">Overdue Project</h3>
          <p className="text-2xl">{caseStats.overdue}</p>
        </div>
      </div>

      {/* Revenue Tracking */}
      <div className="bg-white p-4 rounded shadow">
        <h3 className="text-lg font-semibold mb-2">Total Revenue</h3>
        <p className="text-3xl text-green-600">₹ {revenue.toLocaleString()}</p>
      </div>

      {/* Task and Calendar View */}
      <div className="bg-white p-4 rounded shadow">
        <h3 className="text-lg font-semibold mb-4">Upcoming Tasks</h3>
        <ul className="space-y-2">
          {tasks.length > 0 ? (
            tasks.map((task) => (
              <li key={task._id} className="border-b pb-2">
                <strong>{task.title}</strong> — {new Date(task.dueDate).toLocaleDateString()}
              </li>
            ))
          ) : (
            <p>No upcoming tasks.</p>
          )}
        </ul>
        <div className="mt-4 text-sm text-gray-600">Calendar integration coming soon...</div>
      </div>

      {/* Today's Sent Emails */}
      <div className="bg-white p-4 rounded shadow">
        <h3 className="text-lg font-semibold mb-2">Today's Sent Emails</h3>
        <p className="text-3xl text-blue-600">{emailsSentToday}</p>
      </div>

      {/* Email Analytics */}
      <div className="bg-white p-4 rounded shadow">
        <h3 className="text-lg font-semibold">Emails Sent Today</h3>
        <p className="text-2xl">{emailsSentToday}</p>
      </div>
    </div>
  );
}

export default AnalyticsDashboard;
